/* Kaufweise PDP — Galerie-Interaktion (Thumb-Swap + Prev/Next).
   Presentational, ersetzt die hängende Prototyp-support.js. */
(function () {
  function initGallery(root) {
    var main = root.querySelector('[data-kw-gmain]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kw-thumb]'));
    if (!main || thumbs.length === 0) return;
    var idx = 0;

    function show(i) {
      if (i < 0) i = thumbs.length - 1;
      if (i >= thumbs.length) i = 0;
      idx = i;
      var btn = thumbs[i];
      var src = btn.getAttribute('data-src');
      if (src) main.setAttribute('src', src);
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      btn.classList.add('active');
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { show(i); });
    });
    var prev = root.querySelector('[data-kw-prev]');
    var next = root.querySelector('[data-kw-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  }

  // Liefertermin: Werktage (ohne Sonntag) ab heute, +1 Tag nach Cutoff.
  // Format lokalisiert: de -> "Fr., 10. Juli". Läuft erneut nach Section-Morph
  // (Variantenwechsel ersetzt den Fallback-Text) via MutationObserver.
  function initDelivery() {
    document.querySelectorAll('[data-kw-delivery]:not([data-kw-done])').forEach(function (el) {
      el.setAttribute('data-kw-done', '1');
      var days = parseInt(el.getAttribute('data-days') || '2', 10);
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '11', 10);
      var d = new Date();
      if (d.getHours() >= cutoff) days += 1;
      var counted = 0;
      while (counted < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) counted++;
      }
      var lang = document.documentElement.lang || 'de';
      try {
        el.textContent = d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'long' });
      } catch (e) { /* Fallback-Text bleibt stehen */ }
    });
  }

  // Audit A3-02: Hauptbild folgt der gewaehlten Variante. Horizon rendert die
  // Section beim Variantenwechsel NICHT neu (nur Preis/Form-Id clientseitig),
  // daher hier: nach jedem Wechsel den Thumb des variant.featured_media klicken.
  // Fix 15.09.2026: Die Varianten-ID kommt direkt vom geklickten Optionswert
  // (data-variant-id), NICHT mehr per Timer aus dem Warenkorb-Formular. Horizon
  // schreibt die Formular-ID erst nach dem Nachladen der Section (gemessen ~500 ms),
  // der alte 120-ms-Timer las deshalb die VORHERIGE Variante (Bild eins daneben).
  var productJson = null;
  var productJsonPromise = null;
  function loadProductJson() {
    if (productJson) return Promise.resolve(productJson);
    if (!productJsonPromise) {
      productJsonPromise = fetch(location.pathname.split('?')[0] + '.js')
        .then(function (r) { return r.json(); })
        .then(function (j) { productJson = j; return j; })
        .catch(function () { productJsonPromise = null; return null; });
    }
    return productJsonPromise;
  }
  function variantIdFromTarget(t) {
    if (!t || !t.getAttribute) return null;
    if (t.tagName === 'SELECT') {
      var o = t.options[t.selectedIndex];
      return o ? o.getAttribute('data-variant-id') : null;
    }
    return t.getAttribute('data-variant-id');
  }
  function showVariantMedia(variantId) {
    var gal = document.querySelector('[data-kw-gallery]');
    if (!gal || !variantId) return;
    loadProductJson().then(function (j) {
      if (!j || !j.variants) return;
      var v = null;
      for (var i = 0; i < j.variants.length; i++) {
        if (String(j.variants[i].id) === String(variantId)) { v = j.variants[i]; break; }
      }
      if (!v || !v.featured_media) return;
      var thumb = gal.querySelector('[data-kw-thumb][data-media-id="' + v.featured_media.id + '"]');
      if (thumb) thumb.click();
    });
  }
  // Fallback ohne data-variant-id: warten, bis Horizon die Formular-ID wirklich
  // geaendert hat (Polling statt fester Wartezeit, max. 3 s).
  function waitForFormVariantId(before, cb) {
    var waited = 0;
    (function tick() {
      var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (idInput && idInput.value && idInput.value !== before) { cb(idInput.value); return; }
      waited += 100;
      if (waited <= 3000) setTimeout(tick, 100);
    })();
  }
  function initVariantMedia() {
    if (document.documentElement.hasAttribute('data-kw-vm')) return;
    document.documentElement.setAttribute('data-kw-vm', '1');
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('variant-picker, product-form-component, .variant-option')) return;
      if (!document.querySelector('[data-kw-gallery]')) return;
      var vid = variantIdFromTarget(e.target);
      if (vid) { showVariantMedia(vid); return; }
      var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      waitForFormVariantId(idInput ? idInput.value : null, showVariantMedia);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-kw-gallery]').forEach(initGallery);
    initDelivery();
    initVariantMedia();
  }

  // Section-Morph (Variantenwechsel) setzt den Fallback-Text zurück -> neu rechnen
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (document.querySelector('[data-kw-delivery]:not([data-kw-done])')) initDelivery();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init after section-rendering morphs (variant change re-renders PDP section)
  document.addEventListener('shopify:section:load', initAll);

  // Verwandte Produkte async via Shopify Recommendations-API laden
  if (!customElements.get('kw-recommendations')) {
    customElements.define('kw-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.getAttribute('data-url');
        if (!url || this.dataset.loaded) return;
        this.dataset.loaded = '1';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('kw-recommendations');
          if (incoming && incoming.innerHTML.trim()) {
            this.innerHTML = incoming.innerHTML;
          }
        }.bind(this)).catch(function () {});
      }
    });
  }
})();
